import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Activitykpi, Activity } from 'toolbandi-ui-lib';
import { MessageService, ListService, ListItem, SharedDataService, CrudService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-activitykpi-edit',
	templateUrl: './activitykpi-edit.component.html',
	styleUrls: ['./activitykpi-edit.component.scss']
})
export class ActivitykpiEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	kpi: Activitykpi;
	title: string;

	@Input()
	activityid: number;

	units: ListItem[] = [];
	activity: Activity;

	constructor(
		private messageService: MessageService,
		private translateService: TranslateService,
		private activeModal: NgbActiveModal,
		private listService: ListService,
		private sharedDataService: SharedDataService,
		private activityService: CrudService<Activity>,
		private kpiService: CrudService<Activitykpi>
	) {

		this.listService.getListItemsBySlug('tool.unit').subscribe((data: ListItem[]) => {
			this.units = data;
		});
	}

	ngOnInit() {
		this.loadActivity();
	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	loadActivity(): void {
		this.activityService.getEntity(Activity, 'activity', this.activityid).subscribe((data: Activity) => {
			this.activity = data;
		});
	}

	load(id: number): void {
		if (id) {
			this.loading = true;
			this.kpiService.getEntity(Activitykpi, 'activitykpi', id).subscribe(kpi => {
				this.kpi = kpi;
				this.title = 'kpi-edit';
				this.initItem();
			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.kpi'));
				this.kpi = undefined;
				this.loading = false;
			});

		} else {
			this.kpi = new Activitykpi();
			this.title = 'kpi-create';
			this.kpi.activityid = this.activityid;
			this.loading = false;
		}

	}

	initItem(): void {
		this.loading = false;
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	submit(): void {


		if (!this.kpi.id) {
			this.kpiService.createEntity(Activitykpi, 'activitykpi', this.kpi).subscribe(response => {
				this.kpi = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.kpi-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.kpi);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.kpiService.saveEntity(Activitykpi, 'activitykpi', this.kpi).subscribe(response => {
				this.kpi = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.kpi-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.kpi);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

}
